import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main'
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('WarehouseReceptions', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  warehouseReceptions: [],
  purchaseOrders: []
}

const mutations = {
  ...crud.mutations,
  SET_PURCHASE (state, payload) {
    state.purchaseOrders = payload
  }
}

const actions = {
  ...crud.actions,
  async loadPurcharse ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`purchase-orders?param=${payload.param}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PURCHASE', response.data.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async saveRecption ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.post(`receptions`, payload)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.' + 'receptions', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        commit('SET_PURCHASE', response.data)
        commit('SET_MODAL_VISIBLE', false)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setReceptions ({ commit }, payload) {
    commit('SET_PURCHASE', payload)
  }
}

const getters = {
  ...crud.getters,
  warehouseReceptions: state => state.warehouseReceptions,
  purchaseOrders: state => state.purchaseOrders
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
